module.exports = __webpack_public_path__ + "img/id-card.bbbc533d.png";